import { useState } from 'react';

export enum RequestState {
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export const useRequestState = () => {
  const [requestState, setRequestState] = useState<RequestState | undefined>(undefined);
  const isError = requestState === RequestState.ERROR;

  if (isError) {
    throw new Error('error_data');
  }

  return {
    requestState,
    isLoading: requestState === RequestState.LOADING,
    isSuccess: requestState === RequestState.SUCCESS,
    isError,
    setRequestState,
  };
};
